import eventReporter from '@/utils/event-reporter';
import { platform } from '@/utils/getPlatform';
import { mapGetters, mapState } from 'vuex';
import jump from '@/utils/jump';
import PromoteHandle from '@/models/promote/PromoteHandle';
import sensors from '@/js_sdk/Sensorsdata-UniPlugin-JS/Sensorsdata-UniPlugin-JS/index';
import { throttleNew } from '@/utils/enhance';
import { Base64 } from 'js-base64';
import dayjs from 'dayjs';
import { subscribeNewsGetLongTermSubscribeLog, reportLongSubscribeAliPay } from '@/api/notify';
import { toast } from '@/utils/prompt';
import { getPageKey } from '@/utils';
// 微信端、安卓和苹果部分机型 wepb格式图片显示不出来
const isSupportWebpFlag = platform === 'MP-ALIPAY';
// 默认导航条改变阈值
const navChangeThresholdDefault = 200;
// 正在滚动标识 用于节流
let pageScrolling = false;
export default {
  data() {

    const ua = navigator.userAgent.toLowerCase();

    return {
      platformName: platform, //* 当前端名称, 大写 MP-WEXIN MP-ALIPAY H5
      theme: {
        subject: '#d7092f',
        second: '#f5af18',
      },
      curRoute: '',
      isIpx: false,
      scroll: 0,

      isWechat: /MicroMessenger/i.test(ua),
      isH5Wechat: /MicroMessenger/i.test(ua),
      isQQMusic: /QQMusic/i.test(ua),
      isQQLive: /QQLiveBrowser/i.test(ua),

    };
  },
  computed: {
    ...mapGetters({
      mixIsLogin: 'isLogin',
    }),
    ...mapState({
      mixMemberCO: state => state.memberCO,
    }),
    ...mapGetters({
      memberLevelList: 'memberLevelList', // 会员等级配置列表
    }),
  },
  onLoad(query) {
    this.promoteHandle = new PromoteHandle(query);
    this.promoteHandle.onloadBindPromoter(); // 绑定推广员

    sensors.quick('autoTrackSinglePage');

  },
  onPageScroll(e) {
    // 节流频繁更改数据
    if (pageScrolling) {
      return;
    }
    pageScrolling = true;
    setTimeout(() => {
      pageScrolling = false;
    }, 20);

    const scrollTop = e.scrollTop;
    let opacity = scrollTop / navChangeThresholdDefault;
    if (opacity > 1) {
      opacity = 1;
    }
    const key = getPageKey(this);
    const pageNavChangeOpacity = this.$store.state.pageNavChangeOpacity;
    const oldVal = pageNavChangeOpacity[key];
    const newVal = opacity;
    if (oldVal !== newVal) {
      this.$set(pageNavChangeOpacity, key, newVal);
    }
  },
  // onShow() {

    // sensors.quick('autoTrackSinglePage');

  // },
  // onShow: throttleNew(() => {
  //
  //   sensors.quick('autoTrackSinglePage');
  //
  // }, 300),
  onShareAppMessage() {
    if (!!this.$u.mpShare && !!this.$u.mpShare.path && !!this.isPageShareEnable) {
      const { path = '' } = this.$u.mpShare || {};
      this.$u.mpShare.path = this.promoteHandle.transformPromoterPath(path); // 强制替换参数
      // 以下代码为新增加
      let orginPromter = this.promoteHandle.getAppPromoter();
      if (orginPromter && orginPromter.length > 6) {
        orginPromter = orginPromter.substring(orginPromter.length - 6);
        this.$u.mpShare.imageUrl = this.watermarkImage(this.$u.mpShare.imageUrl, orginPromter);
      }
    } else {
      // 获取当前页面路径
      let currentPage = this.getCurrentPagePath();
      // 增加促销员参数
      currentPage = this.promoteHandle.transformPromoterPath(currentPage);
      // 页面未定义onShareAppMessage,自动填充参数
      return { path: currentPage };
    }
  },
  methods: {
    getCurrentPagePath() {
      const pages = getCurrentPages();
      let currentPage = '';




      currentPage = pages[pages.length - 1].route;

      if (currentPage && currentPage.length > 0 && !currentPage.startsWith('//')) {
        currentPage = '/' + currentPage;
      }
      return currentPage;
    },
    convertWebp(sourceImage, isSupportWebp = isSupportWebpFlag) {
      let isH5 = false;
      if (!sourceImage) {
        return '';
      }
      if (Array.isArray(sourceImage)) {
        sourceImage = sourceImage[0];
      }
      if (!isSupportWebp) {
        return sourceImage;
      }
      if (typeof sourceImage !== 'string') {
        return '';
      }


      isH5 = true;

      if (isH5) {
        return sourceImage;
      }

      // 微信支持webp
      // 支付宝
      sourceImage = sourceImage.split('?')[0];
      if (!isSupportWebp || !sourceImage || sourceImage.indexOf('gif') >= 0) {
        return sourceImage;
      }
      if (!(sourceImage.indexOf('format,webp') >= 0)) {
        if (sourceImage.indexOf('x-oss-process=image') >= 0) {
          sourceImage = sourceImage + '/format,webp';
        } else {
          const lowerCaseImage = sourceImage.toString().toLowerCase();
          if (
            lowerCaseImage.indexOf('png') >= 0 ||
            lowerCaseImage.indexOf('jpg') >= 0 ||
            lowerCaseImage.indexOf('jpeg') >= 0
          ) {
            sourceImage =
              lowerCaseImage.indexOf('?') !== -1
                ? sourceImage + '&x-oss-process=image/format,webp'
                : sourceImage + '?x-oss-process=image/format,webp';
          }
        }
      }
      return sourceImage;
    },
    isMoreThan99: function(orderNumber) {
      if (parseInt(orderNumber) > 99) {
        return '99+';
      } else {
        return orderNumber;
      }
    },
    setData: function(obj, callback) {
      const that = this;
      const handleData = (tepData, tepKey, afterKey) => {
        tepKey = tepKey.split('.');
        tepKey.forEach(item => {
          if (tepData[item] === null || tepData[item] === undefined) {
            const reg = /^[0-9]+$/;
            tepData[item] = reg.test(afterKey) ? [] : {};
            tepData = tepData[item];
          } else {
            tepData = tepData[item];
          }
        });
        return tepData;
      };
      const isFn = function(value) {
        return typeof value === 'function' || false;
      };
      obj &&
        Object.keys(obj).forEach(function(key) {
          const val = obj[key];
          key = key.replace(/\]/g, '').replace(/\[/g, '.');
          let front, after;
          const index_after = key.lastIndexOf('.');
          if (index_after !== -1) {
            after = key.slice(index_after + 1);
            front = handleData(that, key.slice(0, index_after), after);
          } else {
            after = key;
            front = that;
          }
          if (front.$data && front.$data[after] === undefined) {
            Object.defineProperty(front, after, {
              get() {
                return front.$data[after];
              },
              set(newValue) {
                front.$data[after] = newValue;
                that.$forceUpdate();
              },
              enumerable: true,
              configurable: true,
            });
            front[after] = val;
          } else {
            that.$set(front, after, val);
          }
        });
      isFn(callback) && this.$nextTick(callback);
    },
    dateFormat: function(timestamp, format) {
      if (!format) {
        format = 'YYYY-MM-DD HH:mm:ss';
      }
      if (!timestamp) {
        return '';
      }
      let fmt = '';
      format = format.split(' ');
      if (format[0]) {
        fmt = format[0].toLocaleUpperCase();
      }
      if (format[1]) {
        fmt = fmt ? fmt + ' ' + format[1].toLocaleLowerCase() : format[1].toLocaleLowerCase();
        fmt = fmt.replace(/hh/, 'HH');
      }
      return dayjs(timestamp).format(fmt);
    },
    mixHandleLoginJump() {
      if (!this.mixIsLogin) {
        jump.toPage(5);
      }
      return this.mixIsLogin;
    },
    plus(num, num2) {
      let amount = num + num2;
      amount = parseFloat(amount);
      amount = Math.round(amount * 100) / 100;
      return amount;
    },
    filterTemplateIds(codeIds) {
      const tmplIds = [];
      const templateIdsMap = getApp().globalData.templateIdsMap;
      if (!templateIdsMap && templateIdsMap.length <= 0) {
        return tmplIds;
      }
      codeIds.map(name => {
        const value = templateIdsMap.get(name);
        if (value) {
          tmplIds.push(value);
        }
      });
      return tmplIds;
    },
    watermarkImage(sourceImage, text) {
      if (!text) {
        return sourceImage;
      }
      if (!sourceImage) {
        return '';
      }
      if (Array.isArray(sourceImage)) {
        sourceImage = sourceImage[0];
      }
      try {
        if (typeof sourceImage !== 'string') {
          return '';
        }
        sourceImage = sourceImage.split('?')[0];
        if (!sourceImage || sourceImage.indexOf('gif') >= 0) {
          return sourceImage;
        }
        const base64Str = Base64.encode(text);
        const fixedStr = `/resize,m_fill,limit_0,h_600,w_750/watermark,text_${base64Str},color_aaaaaa,size_20,g_se,x_30,y_30`;
        if (sourceImage.indexOf('x-oss-process=image') >= 0) {
          sourceImage = sourceImage + fixedStr;
        } else {
          const lowerCaseImage = sourceImage.toString().toLowerCase();
          if (
            lowerCaseImage.indexOf('png') >= 0 ||
            lowerCaseImage.indexOf('jpg') >= 0 ||
            lowerCaseImage.indexOf('jpeg') >= 0
          ) {
            sourceImage =
              lowerCaseImage.indexOf('?') !== -1
                ? sourceImage + '&x-oss-process=image' + fixedStr
                : sourceImage + '?x-oss-process=image' + fixedStr;
          }
        }
      } catch (e) {}
      return sourceImage;
    },
    /**
     * 订阅消息统一上报方法
     * subscribeArray 上报类型
     * path为false时使用获取到的页面路径，否则为传入自定义路径
     * hasQuery 有值使用该值做参数，无值利用id取options.id
     * */


















    /*
      支付宝长订阅消息查询是否有订阅过
      针对于需要弹出已经长期订阅过的提示语
     */





















  },
};
